import styled from 'styled-components';
import impulsione from '../../Media/logo-impulsionegram.png';
import { device } from '../device';
import './../Styles/button.css';
function Header() {
  return (
    <>
      <nav className="nav-section">
        <div className="navigation header d-flex text-center  col-md-7 col-12 z-index-3">
          <Logo
            href={`https://www.impulsionegram.com.br/?utm_source=ferramenta&utm_medium=seo&utm_campaign=logo-ferramenta`}
            target="_blank"
            className="icon-header"
          >
            <img src={impulsione} alt="" width={'100%'} />
          </Logo>
          <div className="button-seguidores">
            <a
              href={`https://www.impulsionegram.com.br/?utm_source=ferramenta&utm_medium=seo&utm_campaign=cta-ferramenta`}
              target="_blank"
              rel="noreferrer"
            >
              Comprar seguidores
            </a>
          </div>
        </div>
      </nav>

      {/* <nav className="nav-section">
        <div className="navigation flex container justify-content-center text-center m-auto col-md-8 col-12">
          <NavigationMenu />
        </div>
      </nav> */}
    </>
  );
}

const MenuLink = styled.a`
  padding: 1rem 2rem;
  cursor: pointer;

  text-align: center;
  text-decoration: none;
  color: #67bc98;
  transition: all 0.3s ease-in;
  font-size: 0.9rem;
  &:hover {
    background: linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Nav = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* flex-wrap: wrap; */
  background: white;
  /* position: absolute; */

  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.206);
  @media ${device.laptop} {
    padding: -40rem 8rem;
  }
`;

const Logo = styled.a`
  padding: 1rem 0;
  background: linear-gradient(
    45deg,
    #f09433 0%,
    #e6683c 25%,
    #dc2743 50%,
    #cc2366 75%,
    #bc1888 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.7rem;
  span {
    font-weight: 300;
    font-size: 1.3rem;
  }
  display: flex;
`;

const Menu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media (max-width: 768px) {
    overflow: hidden;
    flex-direction: column;
    max-height: ${({ isOpen }) => (isOpen ? '300px' : '0')};
    transition: max-height 0.3s ease-in;
    width: 100%;
  }
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  span {
    height: 2px;
    width: 25px;
    background: #7b7fda;
    margin-bottom: 4px;
    border-radius: 5px;
  }
  @media (max-width: 768px) {
    display: flex;
  }
`;

const Container = styled.div`
  /* background-color: #0d1117; */

  /* display: grid; */
  /* place-items: center; */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.206);
  z-index: 999;
`;
export default Header;
